module.exports = __webpack_public_path__ + "img/scans-page.8724b901.jpg";